import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { initLenis } from "@/components/landing/smooth";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Story } from "@/components/landing/Story";
import { Pillars } from "@/components/landing/Pillars";
import { Transformation } from "@/components/landing/Transformation";
import { CaseStudy } from "@/components/landing/CaseStudy";
import { Differentiators } from "@/components/landing/Differentiators";
import { Learning } from "@/components/landing/Learning";
import { ForWho } from "@/components/landing/ForWho";
import { Investment } from "@/components/landing/Investment";
import { Contact } from "@/components/landing/Contact";
import { Closing } from "@/components/landing/Closing";

function App() {
  useEffect(() => {
    const destroy = initLenis();
    return destroy;
  }, []);

  return (
    <div className="App bg-navy font-body">
      <Toaster position="bottom-center" richColors />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Story />
        <Pillars />
        <Transformation />
        <CaseStudy />
        <Differentiators />
        <Learning />
        <ForWho />
        <Investment />
        <Contact />
      </main>
      <Closing />
    </div>
  );
}

export default App;
